import { render, staticRenderFns } from "./masrafmerkezinegore.vue?vue&type=template&id=79b67a46&"
import script from "./masrafmerkezinegore.vue?vue&type=script&lang=js&"
export * from "./masrafmerkezinegore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports